export default __webpack_public_path__ + "static/mobile-banking-app-development-company-peerbits-325e7dde451e0de43790389540c557a2.png";